import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import useForm from 'components/hooks/useForm';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ErrorMessage from 'components/application/ErrorMessage';
import ModalBox from 'components/application/ModalBox';
import TextField from 'components/application/TextField';

import { defaultFolder } from 'components/projectsDashboard/helpers';

export default function CreateFolderModal({
  isCreateDisabled = false,
  onClose,
  onCreateSubmit,
  onInputFocus,
  requestError,
}) {
  const [currentFolder, , handleCurrentFolderInputChange] =
    useForm(defaultFolder);

  const { t: i18nTCommon } = useTranslation('common');

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTCommon('shared.cancel')}
          </TextButton>
          <FilledButton
            color='mint'
            disabled={currentFolder.name.length === 0 || isCreateDisabled}
            onClick={() => onCreateSubmit({ folderParams: currentFolder })}
          >
            {i18nTCommon('projects.createFolder')}
          </FilledButton>
        </div>
      }
      isOpen={true}
      mode='letterbox'
      onClose={onClose}
    >
      <>
        <div className='modalbox-header tw-border-grey-100'>
          <h2 className='modalbox-header__title truncated-text-container tw-text-l tw-font-semibold tw-text-grey-900'>
            {i18nTCommon('projects.newFolder')}
          </h2>
        </div>
        <div className='modalbox-body'>
          <ErrorMessage
            isFallback={false}
            modifiers='tw-mb-3'
            validationErrors={requestError.validationErrors}
          />
          <TextField
            autoFocus={true}
            fieldError={requestError.validationErrors.name}
            inputClassName='tw-px-3 tw-py-[9px]'
            isRequired={true}
            label={i18nTCommon('projects.folderName')}
            name='name'
            onChange={handleCurrentFolderInputChange}
            placeholder={i18nTCommon('projects.enterUniqueNameForFolder')}
            removeErrorStyling={onInputFocus}
            value={currentFolder.name}
          />
        </div>
      </>
    </ModalBox>
  );
}

CreateFolderModal.propTypes = {
  isCreateDisabled: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onCreateSubmit: PropTypes.func.isRequired,
  onInputFocus: PropTypes.func.isRequired,
  requestError: PropTypes.shape({
    isFallback: PropTypes.bool.isRequired,
    validationErrors: PropTypes.object.isRequired,
  }),
};
